import React from "react";
import { Box, Typography } from "@mui/material";

const Documentation: React.FC = () => {
  return (
    <Box mt="100px" ml="20px">
      <Typography>Documentation</Typography>
    </Box>
  );
};

export default Documentation;
